/**
 * EmptyHint — short Geist Mono eyebrow + Geist body for empty-list contexts.
 *
 * Distinct from EmptyCanvasState (which is the canvas-only "we're listening"
 * surface). Use this primitive for in-panel empty rows where a compact
 * label-and-line treatment is enough.
 */

type EmptyHintProps = {
  title: string;
  body: string;
};

export function EmptyHint({ title, body }: EmptyHintProps) {
  return (
    <div className="text-center">
      <p
        className="kv-eyebrow text-[11px]"
        style={{ color: 'hsl(var(--muted-foreground))' }}
      >
        {title}
      </p>
      <p className="mt-1.5 text-sm" style={{ color: 'hsl(var(--foreground))' }}>
        {body}
      </p>
    </div>
  );
}
